


















































































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import { IGame } from '~/store/games/types';
import { IUser } from '~/store/profile/types';
import MediaCarousel from '~/components/Games/MediaCarousel.vue';
import _debounce from 'lodash.debounce';
import GameActionButton from '~/components/Games/GameActionButton.vue';
import GameRequiredItemButton from '~/components/Games/GameRequiredItemButton.vue';
import GameMobilePlaytestButton from '~/components/Games/GameMobilePlaytestButton.vue';
import { CheckForRequiredItems, GameActionButtonHost } from '~/mixins';

@Component({
  components: {
    GameActionButton,
    GameRequiredItemButton,
    GameMobilePlaytestButton,
    MediaCarousel,
  },
})
export default class GameInfo extends Mixins(
  CheckForRequiredItems,
  GameActionButtonHost,
) {
  @State('discordLink') readonly discordLink!: string;
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @Prop(Object) readonly game!: IGame;

  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  windowWidth = 0;
  debouncedSetWindowWidth = _debounce(this.setWindowWidth, 500);

  isCheckingRequiredItems: boolean = true;
  requireItemButton: boolean = true;

  iosReg = /i(Phone|Pad|Pod)/gi;
  androidReg = /Android/gi;
  userIsIOS: boolean = this.iosReg.test((navigator as any).userAgent);
  userIsAndroid: boolean = this.androidReg.test((navigator as any).userAgent);
  userIsMobile: boolean = this.userIsIOS || this.userIsAndroid;

  created() {
    this.gameActionButtonHostCreated();

    this.$on(this.launcherMessageProcessedEventName, () => {
      const thisGameInstallationStatus = this.gamesInstallStatuses[
        this.game.codeName
      ];
      if (thisGameInstallationStatus) {
        this.game.isInstalled = thisGameInstallationStatus.isInstalled;
        this.game.installedVersion = thisGameInstallationStatus.version;
      }
    });
  }

  mounted() {
    window.addEventListener('resize', this.setWindowWidth);
    if (this.currentUser.loggedIn) {
      this.$store.subscribe(({ type }) => {
        if (type === 'inventory/updateUserItems') {
          this.setRequiredGameItemStatus();
        }
      });
    } else {
      this.setRequiredGameItemStatus();
    }
  }

  destroyed() {
    window.removeEventListener('resize', this.setWindowWidth);
    this.gameActionButtonHostDestroyed({ disableAutoReconnect: true });
  }

  get fetchingReqItem() {
    return this.isCheckingRequiredItems;
  }

  get requireItemButtonStatus() {
    return this.requireItemButton;
  }

  setRequiredGameItemStatus() {
    this.requireItemButton = this.getRequiredGameItemStatus(this.game);
    this.isCheckingRequiredItems = false;
  }

  setWindowWidth(event: any) {
    this.windowWidth = event.target.innerWidth;
  }

  getDownloadableStatus(game: IGame) {
    if (
      game.downloadLink &&
      game.activeStartTimestamp &&
      game.activeEndTimestamp
    ) {
      const now = Date.now();
      const active =
        game.activeStartTimestamp < now && game.activeEndTimestamp > now;
      return active;
    }
    return false;
  }

  handlePlay() {
    if (process.env.displayGameInIframe) {
      if (document.body.requestFullscreen) {
        document.body.requestFullscreen();
      } else if ((document.body as any).webkitRequestFullscreen) {
        (document.body as any).webkitRequestFullscreen();
      }
    }

    this.$router.push(`/games/${this.game.route}/play`);
  }

  apkDownloadClick(gameName: string) {
    // UA tracking
    this.$ua.trackApkDownloadEvent({
      game: gameName,
    });
  }

  iosDownloadClick(gameName: string) {
    // UA tracking
    this.$ua.trackIosDownloadEvent({
      game: gameName,
    });
  }

  onTrackOffsiteNavigation(url?: string) {
    if (!url) {
      return;
    }

    this.$ua.trackNavigationEvent({
      from: window?.location?.href,
      to: url,
    });
  }
}
